var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-master"},[_c('div',{staticClass:"layout-master-content"},[_c('Header'),_c('div',{staticClass:"main",class:{ active: _vm.isActive }},[_c('router-view',{key:_vm.$route.fullPath})],1),_c('Footer',{attrs:{"isActive":_vm.isActive}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }